import { default as PhoneInput } from './PhoneInput';

export default PhoneInput;
